import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=06b0ed92&scoped=true"
import script from "./appFooter.vue?vue&type=script&lang=js"
export * from "./appFooter.vue?vue&type=script&lang=js"
import style0 from "./appFooter.vue?vue&type=style&index=0&id=06b0ed92&prod&lang=scss&scoped=true"
import style1 from "./appFooter.vue?vue&type=style&index=1&id=06b0ed92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0ed92",
  null
  
)

export default component.exports